import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/store";

export const Header = () => {
  const { count, setOpen } = useCart();
  const links = [
    { label: "The Drop", id: "product" },
    { label: "Manifesto", id: "manifesto" },
    { label: "Contact", id: "footer" },
  ];
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className="fixed top-0 left-0 right-0 z-[100] backdrop-blur-xl bg-black/70 border-b border-[var(--line)]"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-anton text-xl md:text-2xl tracking-tight uppercase leading-none"
        >
          Full Send<span className="text-[var(--accent)]">.</span>
        </button>
        <nav className="hidden md:flex items-center gap-10 text-sm font-medium uppercase tracking-widest">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[var(--text-dim)] hover:text-[var(--text)] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="open-cart-btn"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 group"
        >
          <ShoppingBag className="w-6 h-6" strokeWidth={1.6} />
          {count > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -top-2 -right-3 bg-[var(--accent)] text-white text-[11px] font-bold w-5 h-5 flex items-center justify-center rounded-full"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </motion.header>
  );
};
